import Vue from "vue";
import Router from "vue-router";
// 登录
import Login from "../views/users/Login";
//忘记密码，修改密码
import PasswordForget from "../views/users/PasswordForget";
//钉钉扫码登录
import DingDing from "../views/users/DingDing";
//强制修改初始密码
import ForceChangePwd from "../views/users/ForceChangePwd";
//首页
import Home from "../views/Home";
// import Home1 from '../views/Home1'
//404
import NotFound from "../components/404.vue";
import building from "../components/building.vue";
//设备检索
import DeviceSearch from "../views/device/DeviceSearch";
//设备信息页面
import DeviceInfo from "../views/device/DeviceInfo";
//设备详情
import deviceinfoDetail from "../views/device/deviceinfoDetail";
//设备详情-只查看
import deviceinfoDetailOnly from "../views/device/deviceinfoDetailOnly";
// 固定资产卡片
import AssetCard from "../views/device/components/AssetCard";
// 修改设备
import deviceinfoUpdate from "../views/device/deviceinfoUpdate";
//设备台账-添加设备
import deviceinfoAdd from "../views/device/deviceinfoAdd";
//设备部门变更记录
import DeviceDeptChangeHistory from "../views/device/DeviceDeptChangeHistory";
//待设备科审核页面
import Examine_shebeik from "../views/device/Examine_shebeik";
//项目管理页面
import ProjectInfo from "../views/device/Projectinfo";
//项目管理查看项目页面
import ProjectInfo_device from "../views/device/ProjectInfo_device";
//采购管理
import Purchase from "../views/purchase/Purchase";
//采购合同管理
import Contract from "../views/purchase/Contract";
//采购验收
import Check_purchase from "../views/purchase/Check";
//供应商评价
import Evaluate from "../views/purchase/Evaluate";
//设备检定预警
import Warning from "../views/verification/Warning";
//设备检定信息
import Verification from "../views/verification/Verification";
//检定添加
import AddVenfication from "../views/verification/AddVenfication";
//检定详情
import Particulars from "../views/verification/Particulars";
//检定录入
import Affirm from "../views/verification/Affirm";
//检定确认
import Submit from "../views/verification/Submit";
//维保申请
import Maintenance from "../views/maintenance/Maintenance";
//维保审核
import Audit from "../views/maintenance/Audit";
//维保录入
import Input from "../views/maintenance/Input";
//维保确认
import Notarize from "../views/maintenance/Notarize";
//报废管理
import Scrap from "../views/scrap/Scrap";
//报废审批
import Examine from "../views/scrap/Examine";
//报废确认
import Confirmation from "../views/scrap/Confirmation";
//调拨申请
import Allocation from "../views/allocation/Allocation";
//设备调拨
import Select from "../views/allocation/Select";
//调拨审核
import Transfer from "../views/allocation/Transfer";
//调出确认
import Confirm from "../views/allocation/Confirm";
//调入确认
import Confirmin from "../views/allocation/Confirm1";
//流程授权
import ProcessAuthorization from "../views/SystemSettings/ProcessAuthorization";
//任务下达
import Task from "../views/task/Task";
//添加任务
import Distribution from "../views/task/Distribution";
//编辑任务
import TaskEditing from "../views/task/TaskEditing";
//执行任务
import TaskExecution from "../views/task/TaskExecution";
//账号信息管理
import AccountNumber from "../views/SystemSettings/AccountNumber";
//部门管理
import Department from "../views/SystemSettings/Department";
//单位管理
import Company from "../views/SystemSettings/Company";
//角色管理
import Role from "../views/SystemSettings/Role";
//我的待办
import MyNeed from "../views/needMe/MyNeeds";
//设备分类
import DeviceSort from "../views/SystemSettings/DeviceSort";
//任务完成
import Complete from "../views/task/Complete";
//任务评价
import TaskEvaluate from "../views/task/TaskEvaluate";
//规章制度
import Rules from "../views/trainingMaterials/Rules";
//操作日志
import OperationLog from "../views/SystemSettings/OperationLog";
// 资产卡片手机端查看
import deviceCard from "../views/device/DeviceinfoByPhone";
// 使用人员变更
import UserChange from "../views/personnelChange/UserChange";
// 保管人员变更
import Custodian from "../views/personnelChange/Custodian";
// 维保统计
import statistics from "../views/maintenance/statistics";
// 手机端在线预览
import FilePreviewByPhone from "../components/preview/FilePreviewByPhone";
//添加校准
import AddCalibration from "../views/calibration/AddCalibration";
//校准确认
import calibrationAffirm from "../views/calibration/calibrationAffirm";
//校准详情
import calibrationParticulars from "../views/calibration/calibrationParticulars";
// App版本管理
import AppVersion from "../views/app/AppVersion";
//确认提交
import calibrationSubmit from "../views/calibration/calibrationSubmit";
//校准信息
import calibrationVerification from "../views/calibration/calibrationVerification";
//校准预警
import calibrationWarning from "../views/calibration/calibrationWarning";
//添加核查
import AddCorrecting from "../views/selfCorrecting/AddCorrecting";
//核查详情
import correctingParticulars from "../views/selfCorrecting/correctingParticulars";
//核查信息
import correctingVerification from "../views/selfCorrecting/correctingVerification";
//设备核查预警
import correctingWarning from "../views/selfCorrecting/correctingWarning";
//预警选择页面
// import DeviceWarning from "../components/common/DeviceWarning";
//数据字典
import dataDictionary from "../views/SystemSettings/dataDictionary";
//使用记录跳转配置
import UsageJumpConfig from "../views/SystemSettings/UsageJumpConfig";
//项目管理
import projectManage from "../views/SystemSettings/ProjectManage";
//租户管理
import Tenants from "../views/tenants/Tenants";
//设备超市
import Market from "../views/market/Market";
//设备借用记录
import MktRecord from "../views/market/Record";
//确认借出
import RecordConfirm from "../views/market/RecordConfirm";
//项目管理
import MktProject from "../views/market/Project";
//货架管理
import MktShelves from "../views/market/Shelves";
//大屏展示一
import BigScreen1 from "../views/bigScreen/BigScreen1";
//大屏展示二
import BigScreen2 from "../views/bigScreen/BigScreen2";
//大屏展示三
import BigScreen3 from "../views/bigScreen/BigScreen3";

import { login, resetLoginRedirect } from "../api/api";
Vue.use(Router);

const router = new Router({
  // mode:'history',  //去除url地址栏里面的#
  routes: [
    //登录
    { path: "/login", name: "Login", component: Login, hidden: true },
    //忘记密码
    {
      path: "/passwordForget",
      name: "PasswordForget",
      component: PasswordForget,
      hidden: true,
    },
    // 资产卡片手机端
    {
      path: "/deviceCard",
      name: "deviceCard",
      component: deviceCard,
      hidden: true,
    },
    // 在线预览手机端
    {
      path: "/onlineView",
      name: "deviceCard",
      component: FilePreviewByPhone,
      hidden: true,
    },
    //钉钉
    { path: "/dingDing", name: "DingDing", component: DingDing, hidden: true },
    //强制修改密码
    { path: "/forceChangePwd", name: "ForceChangePwd", component: ForceChangePwd, hidden: true },
    //项目管理-查看设备
    {
      path: "/projectinfo_device",
      name: "projectinfo_device",
      component: Home,
      hidden: true,
      children: [
        {
          path: "/projectinfo_device",
          component: ProjectInfo_device,
          name: "设备信息-查看设备",
          meta: { title: "设备信息-查看设备" },
        },
      ],
    },
    //检定详情
    {
      path: "/particulars",
      name: "particulars",
      component: Home,
      hidden: true,
      children: [
        {
          path: "/particulars",
          component: Particulars,
          name: "设备检定-详情",
          meta: { title: "设备检定-详情" },
        },
      ],
    },
    //检定添加
    {
      path: "/AddVenfication",
      name: "AddVenfication",
      component: Home,
      hidden: true,
      children: [
        {
          path: "/AddVenfication",
          component: AddVenfication,
          name: "设备检定-添加",
          meta: { title: "设备检定-添加", name: "设备检定-添加" },
        },
      ],
    },
    //检定确认
    {
      path: "/Submit",
      name: "Submit",
      component: Home,
      hidden: true,
      children: [
        {
          path: "/Submit",
          component: Submit,
          name: "设备检定-确认",
          meta: { title: "设备检定-确认" },
        },
      ],
    },
    //校准详情
    {
      path: "/calibrationParticulars",
      name: "calibrationParticulars",
      component: Home,
      hidden: true,
      children: [
        {
          path: "/calibrationParticulars",
          component: calibrationParticulars,
          name: "设备校准-详情",
          meta: { title: "设备校准-详情" },
        },
      ],
    },
    //校准添加
    {
      path: "/AddCalibration",
      name: "AddCalibration",
      component: Home,
      hidden: true,
      children: [
        {
          path: "/AddCalibration",
          component: AddCalibration,
          name: "设备校准-添加",
          meta: { title: "设备校准-添加", name: "设备校准-添加" },
        },
      ],
    },
    //校准确认
    {
      path: "/calibrationSubmit",
      name: "calibrationSubmit",
      component: Home,
      hidden: true,
      children: [
        {
          path: "/calibrationSubmit",
          component: calibrationSubmit,
          name: "设备校准-确认",
          meta: { title: "设备校准-确认" },
        },
      ],
    },
    //核查详情
    {
      path: "/correctingParticulars",
      name: "correctingParticulars",
      component: Home,
      hidden: true,
      children: [
        {
          path: "/correctingParticulars",
          component: correctingParticulars,
          name: "设备核查-详情",
          meta: { title: "设备核查-详情" },
        },
      ],
    },
    //核查添加
    {
      path: "/AddCorrecting",
      name: "AddCorrecting",
      component: Home,
      hidden: true,
      children: [
        {
          path: "/AddCorrecting",
          component: AddCorrecting,
          name: "设备核查-录入",
          meta: { title: "设备核查-录入", name: "设备核查-录入" },
        },
      ],
    },
    //设备台账详情
    {
      path: "/DeviceDetail",
      name: "toDeviceDetail",
      component: Home,
      hidden: true,
      children: [
        {
          path: "/DeviceDetail",
          component: deviceinfoDetail,
          name: "设备信息-详情",
          meta: { title: "设备信息-详情" },
        },
      ],
    },
    //设备台账详情
    {
      path: "/DeviceDetailOnly",
      name: "toDeviceDetailOnly",
      component: Home,
      hidden: true,
      children: [
        {
          path: "/DeviceDetailOnly",
          component: deviceinfoDetailOnly,
          name: "设备详细信息",
          meta: { title: "设备详细信息" },
        },
      ],
    },
    //设备台账添加
    {
      path: "/deviceinfoAdd",
      name: "deviceinfoAdd",
      component: Home,
      hidden: true,
      children: [
        {
          path: "/deviceinfoAdd",
          component: deviceinfoAdd,
          meta: { keepAlive: true, title: "设备信息-添加" },
          name: "设备信息-添加",
        },
      ],
    },
    //发布任务
    {
      path: "/distribution",
      name: "distribution",
      component: Home,
      hidden: true,
      children: [
        {
          path: "/distribution",
          component: Distribution,
          name: "任务信息-发布",
          meta: { title: "任务信息-发布" },
        },
      ],
    },
    //编辑任务
    {
      path: "/taskEditing",
      name: "taskEditing",
      component: Home,
      hidden: true,
      children: [
        {
          path: "/taskEditing",
          component: TaskEditing,
          name: "任务信息-编辑",
          meta: { title: "任务信息-编辑" },
        },
      ],
    },
    // 修改设备
    {
      path: "/deviceinfoUpdate",
      name: "deviceinfoUpdate",
      component: Home,
      hidden: true,
      children: [
        {
          path: "/deviceinfoUpdate",
          component: deviceinfoUpdate,
          name: "设备信息-编辑",
          meta: { title: "设备信息-编辑" },
        },
      ],
    },
    // 跳转待办
    {
      path: "/myNeed",
      name: "myNeed",
      component: Home,
      hidden: true,
      children: [
        {
          path: "/myNeed",
          component: MyNeed,
          name: "待办信息",
          meta: { title: "待办信息" },
        },
      ],
    },
    //固定资产卡片AssetCard
    {
      path: "/AssetCard",
      name: "AssetCard",
      component: Home,
      hidden: true,
      children: [
        {
          path: "/AssetCard",
          component: AssetCard,
          name: "AssetCard",
          meta: { title: "设备信息-资产卡片" },
        },
      ],
    },
    // home页面
    // {path: '/home1', name: 'home1', component: Home1, hidden: true,},
    {
      path: "/DeviceInfo",
      component: Home,
      iconCls: "el-icon-s-home",
      hidden: false,
      id: "1",
      name: "设备档案",
      children: [
        {
          id: "2",
          path: "/DeviceInfo",
          component: DeviceInfo,
          hidden: false,
          meta: { keepAlive: true, title: "设备信息" },
          name: "设备信息",
        }, //meta: {keepAlive: true}设置页面不刷新
        {
          id: "3",
          path: "/Examine_shebeik",
          component: Examine_shebeik,
          hidden: false,
          name: "设备审核",
          meta: { title: "设备审核" },
        },
        {
          id: "4",
          path: "/projectInfo",
          component: ProjectInfo,
          hidden: false,
          name: "项目管理",
          meta: { title: "项目管理" },
        },
        {
          id: "213",
          path: "/DeviceSearch",
          component: DeviceSearch,
          hidden: false,
          name: "设备检索",
          meta: { title: "设备检索" },
        },
        {
          id: "221",
          path: "/DeviceDeptChangeHistory",
          component: DeviceDeptChangeHistory,
          hidden: false,
          name: "变更记录",
          meta: { title: "变更记录" },
        },
      ],
    },
    {
      path: "/Market",
      component: Home,
      iconCls: "el-icon-school",
      hidden: false,
      id: "203",
      name: "设备超市",
      children: [
        {
          id: "204",
          path: "/Market",
          component: Market,
          hidden: false,
          meta: { keepAlive: true, title: "设备列表" },
          name: "设备列表",
        },
        {
          id: "205",
          path: "/MktRecord",
          component: MktRecord,
          hidden: false,
          meta: { keepAlive: true, title: "借用记录" },
          name: "借用记录",
        },
        {
          id: "206",
          path: "/RecordConfirm",
          component: RecordConfirm,
          hidden: false,
          meta: { keepAlive: true, title: "确认借出" },
          name: "确认借出",
        },
        {
          id: "207",
          path: "/MktProject",
          component: MktProject,
          hidden: false,
          meta: { keepAlive: true, title: "项目管理" },
          name: "项目管理",
        },
        {
          id: "212",
          path: "/MktShelves",
          component: MktShelves,
          hidden: false,
          meta: { keepAlive: true, title: "货架管理" },
          name: "货架管理",
        },
      ],
    },
    {
      id: "205",
      name: "系统大屏1",
      hidden: true,
      path: "/bigScreen1",
      component: BigScreen1,
    },
    {
      id: "205",
      name: "系统大屏2",
      hidden: true,
      path: "/bigScreen2",
      component: BigScreen2,
    },
    {
      id: "205",
      name: "系统大屏3",
      hidden: true,
      path: "/bigScreen3",
      component: BigScreen3,
    },
    {
      path: "/",
      component: Home,
      iconCls: "el-icon-shopping-cart-2",
      id: "5",
      name: "采购管理",
      hidden: false,
      children: [
        {
          id: "147",
          path: "/purchase",
          component: Purchase,
          hidden: false,
          name: "采购列表",
          meta: { title: "采购列表" },
        },
        {
          id: "148",
          path: "/contract",
          component: Contract,
          hidden: false,
          name: "采购合同管理",
          meta: { title: "采购合同管理" },
        },
        {
          id: "149",
          path: "/check_purchase",
          component: Check_purchase,
          hidden: false,
          name: "采购验收",
          meta: { title: "采购验收" },
        },
        {
          id: "150",
          path: "/evaluate",
          component: Evaluate,
          hidden: false,
          name: "供应商评价",
          meta: { title: "供应商评价" },
        },
      ],
    },
    {
      path: "/",
      component: Home,
      iconCls: "el-icon-user-solid",
      id: "48",
      name: "人员变更",
      hidden: false,
      children: [
        {
          id: "171",
          path: "/userUpdate",
          component: UserChange,
          hidden: false,
          name: "使用人变更",
          meta: { title: "使用人变更" },
        },
        {
          id: "172",
          path: "/keeperUpdate",
          component: Custodian,
          hidden: false,
          name: "保管员变更",
          meta: { title: "保管员变更" },
        },
      ],
    },
    {
      path: "/",
      component: Home,
      iconCls: "el-icon-truck",
      id: "22",
      name: "调拨管理",
      hidden: false,
      children: [
        {
          id: "160",
          path: "/allocation",
          component: Allocation,
          hidden: false,
          name: "调拨列表",
          meta: { keepAlive: true, title: "调拨列表" },
        },
        {
          id: "161",
          path: "/transfer",
          component: Transfer,
          hidden: false,
          name: "调拨审核",
          meta: { title: "调拨审核" },
        },
        {
          id: "181",
          path: "/select",
          component: Select,
          hidden: false,
          name: "设备调拨",
          meta: { title: "设备调拨" },
        },
        {
          id: "162",
          path: "/confirmout",
          component: Confirm,
          hidden: false,
          name: "调出确认",
          meta: { title: "调出确认" },
        },
        {
          id: "163",
          path: "/confirmin",
          component: Confirmin,
          hidden: false,
          name: "调入确认",
          meta: { title: "调入确认" },
        },
      ],
    },
    {
      path: "/",
      component: Home,
      iconCls: "el-icon-circle-check",
      id: "10",
      name: "设备检定",
      hidden: false,
      children: [
        {
          id: "174",
          path: "/warning",
          component: Warning,
          hidden: false,
          name: "检定预警",
          meta: { keepAlive: true, title: "检定预警" },
        },
        {
          id: "151",
          path: "/verification",
          component: Verification,
          hidden: false,
          name: "检定列表",
          meta: { keepAlive: true, title: "检定列表" },
        },
        {
          id: "152",
          path: "/checkInsert",
          component: Affirm,
          hidden: false,
          name: "检定确认",
          meta: { keepAlive: true, title: "检定确认" },
        },
      ],
    },
    {
      path: "/",
      component: Home,
      iconCls: "el-icon-aim",
      id: "55",
      name: "设备校准",
      hidden: false,
      children: [
        {
          id: "176",
          path: "/calibrationWarning",
          component: calibrationWarning,
          hidden: false,
          name: "校准预警",
          meta: { keepAlive: true, title: "校准预警" },
        },
        {
          id: "177",
          path: "/calibrationVerification",
          component: calibrationVerification,
          hidden: false,
          name: "校准列表",
          meta: { keepAlive: true, title: "校准列表" },
        },
        {
          id: "178",
          path: "/calibrationAffirm",
          component: calibrationAffirm,
          hidden: false,
          name: "校准确认",
          meta: { keepAlive: true, title: "校准确认" },
        },
      ],
    },
    {
      path: "/",
      component: Home,
      iconCls: "el-icon-aim",
      id: "59",
      name: "设备核查",
      hidden: false,
      children: [
        {
          id: "179",
          path: "/correctingWarning",
          component: correctingWarning,
          hidden: false,
          name: "核查预警",
          meta: { keepAlive: true, title: "核查预警" },
        },
        {
          id: "180",
          path: "/correctingVerification",
          component: correctingVerification,
          hidden: false,
          name: "核查列表",
          meta: { keepAlive: true, title: "核查列表" },
        },
      ],
    },

    {
      path: "/",
      component: Home,
      iconCls: "el-icon-setting",
      id: "13",
      name: "维保管理",
      hidden: false,
      children: [
        {
          id: "153",
          path: "/maintenance",
          component: Maintenance,
          hidden: false,
          name: "维保列表",
          meta: { title: "维保列表" },
        },
        {
          id: "154",
          path: "/audit",
          component: Audit,
          hidden: false,
          name: "维保审核",
          meta: { title: "维保审核" },
        },
        {
          id: "155",
          path: "/input",
          component: Input,
          hidden: false,
          name: "维保录入",
          meta: { title: "维保录入" },
        },
        {
          id: "156",
          path: "/notarize",
          component: Notarize,
          hidden: false,
          name: "维保确认",
          meta: { title: "维保确认" },
        },
        {
          id: "175",
          path: "/statistics",
          component: statistics,
          hidden: false,
          name: "维保统计",
          meta: { title: "维保统计" },
        },
      ],
    },
    {
      path: "/",
      component: Home,
      iconCls: "el-icon-folder-delete",
      id: "18",
      name: "报废管理",
      hidden: false,
      children: [
        {
          id: "157",
          path: "/scrap",
          component: Scrap,
          hidden: false,
          name: "报废列表",
          meta: { title: "报废列表" },
        },
        {
          id: "158",
          path: "/examine",
          component: Examine,
          hidden: false,
          name: "报废审核",
          meta: { title: "报废审核" },
        },
        {
          id: "159",
          path: "/confirmation",
          component: Confirmation,
          hidden: false,
          name: "报废确认",
          meta: { title: "报废确认" },
        },
      ],
    },
    {
      path: "/",
      component: Home,
      iconCls: "el-icon-tickets",
      id: "27",
      name: "计划任务",
      hidden: false,
      children: [
        {
          id: "164",
          path: "/task",
          component: Task,
          hidden: false,
          name: "任务信息",
          meta: { title: "任务信息" },
        },
        {
          id: "165",
          path: "/taskExecution",
          component: TaskExecution,
          hidden: false,
          name: "任务执行",
          meta: { title: "任务执行" },
        },
        {
          id: "166",
          path: "/complete",
          component: Complete,
          hidden: false,
          name: "任务完成",
          meta: { title: "任务完成" },
        },
        {
          id: "167",
          path: "/taskEvaluate",
          component: TaskEvaluate,
          hidden: false,
          name: "任务评价",
          meta: { title: "任务评价" },
        },
      ],
    },
    {
      path: "/",
      component: Home,
      iconCls: "el-icon-document",
      id: "51",
      name: "使用记录",
      hidden: false,
      children: [
        {
          id: "173",
          path: "/use_record",
          component: null,
          hidden: false,
          name: "使用信息",
          meta: { title: "使用信息" },
        },
      ],
    },
    {
      path: "/",
      component: Home,
      iconCls: "el-icon-user",
      id: "32",
      name: "我的待办",
      hidden: false,
      children: [
        {
          id: "168",
          path: "/myNeed",
          component: MyNeed,
          hidden: false,
          name: "待办信息",
          meta: { title: "待办信息" },
        },
      ],
    },
    {
      path: "/",
      component: Home,
      iconCls: "el-icon-collection",
      id: "34",
      name: "培训资料",
      hidden: false,
      children: [
        // {id: '35',path: '/rules', component: Rules, hidden: false,name: '规章制度', meta: {title: "规章制度"}  },
        {
          id: "169",
          path: "/information",
          component: Rules,
          hidden: false,
          name: "资料管理",
          meta: { title: "资料管理" },
        },
        // { id: '36', path: '/NotFound', component: NotFound, hidden: true, name: '技术文档', meta: { title: "技术文档" } },
        // { id: '37', path: '/NotFound', component: NotFound, hidden: true, name: '产品说明书', meta: { title: "产品说明书" } },
      ],
    },
    {
      path: "/",
      component: Home,
      iconCls: "el-icon-s-tools",
      id: "38",
      name: "系统设置",
      hidden: false,
      children: [
        {
          id: "218",
          path: "/tenants",
          component: Tenants,
          hidden: false,
          name: "租户管理",
          meta: { title: "租户管理" },
        },
        {
          id: "39",
          path: "/accountNumber",
          component: AccountNumber,
          hidden: false,
          name: "账户信息管理",
          meta: { title: "账户信息管理" },
        },
        {
          id: "40",
          path: "/department",
          component: Department,
          hidden: true,
          name: "部门信息管理",
          meta: { title: "部门信息管理" },
        },
        {
          id: "41",
          path: "/role",
          component: Role,
          hidden: false,
          name: "角色信息管理",
          meta: { title: "角色信息管理" },
        },
        {
          id: "42",
          path: "/processAuthorization",
          component: ProcessAuthorization,
          hidden: false,
          name: "业务流程授权",
          meta: { title: "业务流程授权" },
        },
        {
          id: "43",
          path: "/company",
          component: Company,
          hidden: false,
          name: "单位信息管理",
          meta: { title: "单位信息管理" },
        },
        {
          id: "44",
          path: "/deviceSort",
          component: DeviceSort,
          hidden: false,
          name: "设备分类维护",
          meta: { title: "设备分类维护" },
        },
        {
          id: "193",
          path: "/projectManage",
          component: projectManage,
          hidden: false,
          name: "项目分类维护",
          meta: { title: "项目分类维护" },
        },
        // { id: '45', path: '/NotFound', component: NotFound, hidden: false, name: '用户角色授权', meta: { title: "用户角色授权" } },
        {
          id: "46",
          path: "/dictionary_data",
          component: dataDictionary,
          hidden: false,
          name: "数据字典",
          meta: { title: "数据字典" },
        },
        {
          id: "47",
          path: "/OperationLog",
          component: OperationLog,
          hidden: false,
          name: "操作日志",
          meta: { title: "操作日志" },
        },
        {
          id: "219",
          path: "/AppVersion",
          component: AppVersion,
          hidden: false,
          name: "App版本管理",
          meta: { title: "App版本管理" },
        },
        {
          id: "223",
          path: "/usageJumpConfig",
          component: UsageJumpConfig,
          hidden: false,
          name: "使用记录跳转配置",
          meta: { title: "使用记录跳转配置" },
        },
      ],
    },
  ],
});
router.beforeEach((to, from, next) => {
  // 用户从登录页导航到其他页面时，重定向标志，允许下次过期再跳转
  if (from.path === '/login' && to.path !== '/login') {
    resetLoginRedirect();
  }
  if (
    to.path === "/login" ||
    to.path === "/passwordForget" ||
    to.path === "/forceChangePwd" ||
    to.path === "/dingDing" ||
    to.path.indexOf("/dingDing") != -1 ||
    to.path.indexOf("/onlineView") != -1 ||
    to.path.indexOf("/deviceCard") != -1
  ) {
    next();
  } else {
    let token = localStorage.getItem("token");
    if (token === null || token === "") {
      next("/login");
    } else {
      let newTokenTime = new Date().getTime();
      let timelen = 60 * 60 * 24 * 30 * 12 * 1000; // 12个月
      if (newTokenTime - token > timelen) {
        localStorage.removeItem("token");
        sessionStorage.clear();
        next("/login");
      } else {
        next();
      }
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/router.js